import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
    control: {
        position: 'relative',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        wordBreak: 'break-all',
    },
}))

const FormHeader: React.FC = ({ children }) => {
    const classes = useStyles()

    return <div className={classes.control}>{children}</div>
}

export { FormHeader }
